// extracted by mini-css-extract-plugin
export default {"root__label":"style-module__root__label___Rzc70","root__input":"style-module__root__input___donj3","root__area":"style-module__root__area___rLIsb","root__message":"style-module__root__message___sW8aZ"};
    if(module.hot) {
      // 1729151133866
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  